
import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';


const previewContent = {
  archetype: "Discover the symbols that illuminate your strengths and shadows.",
  journal: "Reflect on inner whispers, track your emotional journeys.",
  ritual: "Awaken your day with grounding practices and gentle guidance.",
  chat: "Explore your thoughts in real time, guided by mindful conversation."
};

export default function Soulspace() {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    function handleClick(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [isOpen]);

  return (
    <div ref={containerRef} className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="font-semibold text-indigo-200 hover:text-yellow-200 transition-colors duration-300 relative after:content-[''] after:absolute after:w-full after:h-[2px] after:left-0 after:bottom-0 after:bg-gradient-to-r after:from-yellow-300 after:to-indigo-500 after:scale-x-0 after:origin-left hover:after:scale-x-100 after:transition-transform after:duration-500 whitespace-nowrap"
      >
        ✨ Balance →
      </button>

      {isOpen && (
        <div className="absolute top-full mt-2 w-80 max-w-[calc(100vw-2rem)] bg-black/90 border border-white/30 rounded-2xl p-4 space-y-3 shadow-2xl z-50 left-0 md:right-0 md:left-auto">
          <Link
            to="/sanctuary/archetype"
            className="block bg-linear-to-r from-sky-600 to-indigo-700 text-white rounded-xl px-4 py-3 hover:scale-105 transition-all duration-300 hover:shadow-lg"
            onClick={() => setIsOpen(false)}
          >
            <h3 className="text-lg font-bold capitalize">Archetype</h3>
            <p className="text-sm text-teal-100 leading-relaxed">{previewContent.archetype}</p>
          </Link>
          <Link
            to="/sanctuary/journal"
            className="block bg-linear-to-r from-sky-600 to-indigo-700 text-white rounded-xl px-4 py-3 hover:scale-105 transition-all duration-300 hover:shadow-lg"
            onClick={() => setIsOpen(false)}
          >
            <h3 className="text-lg font-bold capitalize">Journal</h3>
            <p className="text-sm text-teal-100 leading-relaxed">{previewContent.journal}</p>
          </Link>
          <Link
            to="/sanctuary/rituals"
            className="block bg-linear-to-r from-sky-600 to-indigo-700 text-white rounded-xl px-4 py-3 hover:scale-105 transition-all duration-300 hover:shadow-lg"
            onClick={() => setIsOpen(false)}
          >
            <h3 className="text-lg font-bold capitalize">Ritual</h3>
            <p className="text-sm text-teal-100 leading-relaxed">{previewContent.ritual}</p>
          </Link>
        </div>
      )}
    </div>
  );
}
